import React, { useEffect, useState } from "react";
import './Profile.css';
import { getProfile } from "../../../services/loginService";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from '../../../utils/validations';

const Profile = () => {
  const [profile, setProfile] = useState(null); // Change to null instead of an empty array
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const navigate = useNavigate();

  const employeeId = localStorage.getItem('employeeId');

  // Fetch the employee profile data
  const fetchEmployeeProfile = async () => {
    try {
      const data = await getProfile(employeeId);
      setProfile(data); // Set profile to the returned data
    } catch (err) {
      setError('Failed to fetch profile data');
    } finally {
      setLoading(false); // Set loading to false after the fetch completes
    }
  };

  useEffect(() => {
    fetchEmployeeProfile();
  }, []); // Empty dependency array to fetch the profile only once

  if (loading) {
    return <div>Loading...</div>; // Show loading state while data is being fetched
  }

  if (error) {
    return <div>{error}</div>; // Show error message if the fetch fails
  }

  // const details = () => {
  //  // navigate(`/personaldetails?employeeUniqueId=${employeeUniqueId}`);
  //   navigate(`/registrationnavbar`);
  //   localStorage.setItem("employeeUniqueId",profile.employeeUniqueId);
  // };
  const details = (employeeUniqueId) => {
    console.log("Navigating with employeeUniqueId:", employeeUniqueId);
    navigate("/registrationnavbar", {
      state: { applicationId: employeeUniqueId }
    });
  };
return (
  <div className="profile-container">
    <h2>Profile</h2>
    {profile ? (
      <>
        <div className="profile-photo">
          <img
            src={profile.photoUrl || "https://via.placeholder.com/150"} // fallback image
            alt="Profile"
            className="profile-img"
          />
        </div>

        <div className="profile-details">
          <div className="profile-row">
            <span className="label">Employee ID</span> :
            <span className="value">{profile.employeeId || "N/A"}</span>
          </div>
          <div className="profile-row">
            <span className="label">Full Name</span> :
            <span className="value">{capitalizeFirstLetter(profile.fullName )|| "N/A"}</span>
          </div>
          <div className="profile-row">
            <span className="label">Designation</span> :
            <span className="value">{capitalizeFirstLetter(profile.designation) || "N/A"}</span>
          </div>
          <div className="profile-row">
            <span className="label">Contact Number</span> :
            <span className="value">{profile.contactNumber || "N/A"}</span>
          </div>
          <div className="profile-row">
            <span className="label">Email Address</span> :
            <span className="value">{profile.email || "N/A"}</span>
          </div>
        </div>

        <div>
          <button
            className="view-click"
            onClick={() => details(profile.employeeUniqueId)}
          >
            View
          </button>
        </div>
      </>
    ) : (
      <div>No profile data available</div>
    )}
  </div>
);

};

export default Profile;
